<template>
  <div v-if="videos.length" class="youtube-slider">
    <header class="youtube-slider__header">
      <div class="youtube-slider__title-wrap">
        <h3 class="youtube-slider__title">{{ title }}</h3>
        <a v-if="link" :href="link" class="youtube-slider__more">
          {{ computedLinkTitle }}
        </a>
      </div>
      <div class="youtube-slider__navigation">
        <div class="swiper-button-prev" :class="[transliterate(title) + '-prev']" slot="button-prev"></div>
        <div class="swiper-button-next" :class="[transliterate(title) + '-next']" slot="button-next"></div>
      </div>
    </header>
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide class="swiper-item" v-for="(item, i) in videos" :key="i">
        <YoutubeItem
          :link="item.url"
          :video-id="item.video_id"
          :title="item.title"
          :image="item.image_src"
          :date="item.published_at"
          :block-name="titleAnalytics"
          :position="i + 1"
          is-slider
        />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { transliteration } from '@/mixins/transliteration'
import { isTouch } from '@/mixins/isTouchDevice'
import YoutubeItem from './YoutubeItem'
import { getVideoMicrodata } from '@/helpers/microdata/getVideoMicrodata'
import { mapActions } from 'vuex'
import { getIsoDateStr } from '@/helpers/getIsoDateStr'

export default {
  name: 'YoutubeSlider',
  mixins: [transliteration, isTouch],
  props: {
    title: {
      type: String,
      default: ''
    },
    titleAnalytics: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    linkTitle: {
      type: String,
      default: ''
    },
    videos: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    YoutubeItem
  },
  computed: {
    computedLinkTitle () {
      return this.linkTitle || this.$t('see_all')
    }
  },
  data () {
    return {
      swiperOption: {
        spaceBetween: 30,
        slidesPerView: 1.5,
        navigation: {
          nextEl: '.' + this.transliterate(this.title) + '-next',
          prevEl: '.' + this.transliterate(this.title) + '-prev'
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        preloadImages: false,
        breakpoints: {
          319: {
            spaceBetween: 30,
            slidesPerView: 1.2
          },
          550: {
            spaceBetween: 10,
            slidesPerView: 2.3
          },
          769: {
            spaceBetween: 20,
            slidesPerView: 3
          }
        }
      }
    }
  },
  methods: {
    ...mapActions('microdata', ['APPEND_ITEM_TO_LIST']),
    addMicrodata () {
      if (this.videos.length) {
        this.APPEND_ITEM_TO_LIST({
          '@type': 'ItemList',
          'name': this.title,
          'itemListElement': this.videos.map(video => {
            return getVideoMicrodata({
              title: video.title,
              contentUrl: video.url,
              uploadDate: getIsoDateStr(video.published_at),
              thumbnailUrl: video.image_src
            })
          })
        })
      }
    }
  },
  created () {
    this.addMicrodata()
  }
}
</script>

<style scoped lang="sass">
@import "../../../../node_modules/swiper/css/swiper.min.css"

@import "../../../styles/swiper/swiper"

.youtube-slider ::v-deep
  .swiper-wrapper
    align-items: flex-start

.youtube-slider__header
  padding: 0 15px

.swiper-container
  padding: 0 15px

.youtube-slider__header
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  align-items: center
  margin-bottom: 15px

  +mmin($tablet)
    margin-bottom: 30px

.youtube-slider__title-wrap
  display: flex
  flex-flow: row wrap
  align-items: baseline
  justify-content: space-between
  width: 100%

  +mmin($tablet)
    width: auto
    justify-content: flex-start

.youtube-slider__title
  font-size: 18px
  font-weight: 500
  padding: 0
  margin: 0

  +mmin($tablet)
    font-size: 24px

.youtube-slider__more
  color: $main-color
  font-size: 14px
  font-weight: 400 //Rubik 300

  +mmin($tablet)
    font-size: 16px
    margin-left: 20px

  &:hover,
  &:focus,
  &:active
    color: $main-color--hover

.youtube-slider__navigation
  display: none
  position: relative
  width: 70px

  +mmin($tablet)
    display: block

</style>
